const PHRASE =
  "Napoli Lounge · Enjoy the summer · Suoni sofisticati dal cuore di Napoli · ";

export default function Marquee() {
  const text = PHRASE.repeat(4);
  return (
    <div data-testid="marquee" className="w-full overflow-hidden" aria-hidden>
      <div className="animate-marquee flex whitespace-nowrap font-serif italic text-base sm:text-lg text-sky-900/15">
        <span className="pr-2">{text}</span>
        <span className="pr-2">{text}</span>
      </div>
    </div>
  );
}
